import { render, staticRenderFns } from "./InterestingFacts.vue?vue&type=template&id=536a463e&"
import script from "./InterestingFacts.vue?vue&type=script&lang=js&"
export * from "./InterestingFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports